<template>
  <el-space wrap>
  <el-card style="min-width: 320px; max-width: 640px" v-for="(item, index) in dataRef.list"
           :key="index">
    <template #header>
      <div class="card-header">
        <span>{{item.name}}
          <span :style="{color:item.profit>0?'red':'green'}">
          <span style="font-size: 20px;margin-left: 5px;" >{{formatRate(item.profitRate)}}</span>
          <span style="color: red;font-size: 16px;margin-left: 5px;">{{formatUsdtPlus(item.profit)}}</span>
            </span>
        </span>
      </div>
    </template>
    <div>资产 <el-button link @click="openHistoryDialog(item.id)" type="primary">资产记录</el-button> </div>
    <el-descriptions

      direction="vertical"
      :column="4"
      :size="'default'"
      border
    >
      <el-descriptions-item label="BTC" label-align="center">{{formatCoin(item.btcBalance)}}</el-descriptions-item>
      <el-descriptions-item label="ETH" label-align="center">{{formatCoin(item.ethBalance)}}</el-descriptions-item>
      <el-descriptions-item label="USDT" label-align="center">{{formatUsdt(item.usdtBalance)}}</el-descriptions-item>
      <el-descriptions-item label="合计" label-align="center">{{formatUsdt(item.usdValue)}}</el-descriptions-item>
      <el-descriptions-item label="本金" label-align="center">{{formatUsdt(item.costUsdt)}}</el-descriptions-item>
      <el-descriptions-item label="增长" label-align="center"><span :style="{color:item.profit>0?'red':'green'}">{{formatUsdtPlus(item.profit)}}</span></el-descriptions-item>
      <el-descriptions-item label="增长率" label-align="center"><span :style="{color:item.profit>0?'red':'green'}">{{formatRate(item.profitRate)}}</span></el-descriptions-item>
      <el-descriptions-item label="年化" label-align="center"><span :style="{color:item.profit>0?'red':'green'}">{{formatRate(item.profitYear)}}</span></el-descriptions-item>
    </el-descriptions>
    <div>仓位</div>
    <el-descriptions
      direction="vertical"
      :column="4"
      :size="'default'"
      border
    >
      <el-descriptions-item label="BTC仓位" label-align="center">{{formatCoin(item.btcSell)}}</el-descriptions-item>
      <el-descriptions-item label="利润" label-align="center"><span :style="{color:item.btcUnrealized>0?'red':'green'}">{{formatCoin(item.btcUnrealized)}}</span></el-descriptions-item>
      <el-descriptions-item label="ETH仓位" label-align="center">{{formatCoin(item.ethSell)}}</el-descriptions-item>
      <el-descriptions-item label="利润" label-align="center"><span :style="{color:item.ethUnrealized>0?'red':'green'}">{{formatCoin(item.ethUnrealized)}}</span></el-descriptions-item>
    </el-descriptions>
  </el-card>

    <el-card style="min-width: 300px; max-width: 640px" v-if="dataRef.spot">
      <template #header>
        <div class="card-header">
        <span>10号BTC</span>
        </div>
      </template>
      <div>资产</div>
<table class="tb"><tbody>
  <tr><th class="td-head">币种</th><th class="td-head">BTC</th><th class="td-head">USDT</th></tr>
  <tr><th class="td-head">本金</th><td class="td-cell">{{formatCoin(dataRef.spot.costBtc)}}</td>
    <td class="td-cell">{{formatUsdt(dataRef.spot.costUsdt)}}</td></tr>
  <tr><th class="td-head">余额</th><td class="td-cell">{{formatCoin(dataRef.spot.btcBalance)}}</td>
    <td class="td-cell">{{formatUsdt(dataRef.spot.usdtBalance)}}</td></tr>
  <tr><th class="td-head">利润</th>
    <td class="td-cell" :style="{color:(dataRef.spot.btcBalance-dataRef.spot.costBtc)>0?'red':'green'}">{{formatCoinPlus(dataRef.spot.btcBalance-dataRef.spot.costBtc)}}</td>
    <td class="td-cell" :style="{color:(dataRef.spot.usdtBalance-dataRef.spot.costUsdt)>0?'red':'green'}">{{formatUsdt(dataRef.spot.usdtBalance-dataRef.spot.costUsdt)}}</td>
  </tr>
  <tr><th class="td-head">利润比</th>
    <td class="td-cell" :style="{color:(dataRef.spot.btcBalance-dataRef.spot.costBtc)>0?'red':'green'}">{{formatRate((dataRef.spot.btcBalance-dataRef.spot.costBtc)/dataRef.spot.costBtc)}}</td>
    <td class="td-cell" :style="{color:(dataRef.spot.usdtBalance-dataRef.spot.costUsdt)>0?'red':'green'}">{{formatRate((dataRef.spot.usdtBalance-dataRef.spot.costUsdt)/dataRef.spot.costUsdt)}}</td>
    </tr>
</tbody></table>
      <div style="height: 62px;display: block"></div>
    </el-card>
  </el-space>
  <HistoryViewDialog ref="historyViewDialogRef" />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import rest from "@/rest";
import { ElMessage } from "element-plus";
import HistoryViewDialog from "@/views/HistoryViewDialog.vue";

const formatRate = (profitRate:number) => {
  if (!profitRate) return " - ";
  return (profitRate > 0 ? "+" : "") + (profitRate * 100).toFixed(2) + "%";
};

const formatUsdt = (usdt?:number) => {
  if (!usdt) return " - ";
  return usdt.toFixed(2);
};

const formatCoin = (usdt?:number) => {
  if (!usdt) return " - ";
  return usdt.toFixed(4);
};

const formatCoinPlus = (usdt?:number) => {
  if (!usdt) return " - ";
  if (usdt > 0) return "+" + usdt.toFixed(4);
  return usdt.toFixed(4);
};

const formatUsdtPlus = (usdt?:number) => {
  if (!usdt) return " - ";
  if (usdt > 0) return "+" + usdt.toFixed(2);
  return usdt.toFixed(2);
};

export default defineComponent({
  components: { HistoryViewDialog },
  emits: [],
  expose: [],
  setup (props) {
    const dataRef = ref<Record<string, any>>({});
    const historyViewDialogRef = ref<InstanceType<typeof HistoryViewDialog>|null>(null);
    const loadData = () => {
      console.log("loadData");
      rest.baFutureData({ action: "MANAGE", data: {} }, (res:any) => {
        dataRef.value = res;
      }, (error:any) => {
        ElMessage.error(error.message);
      }
      );
    };

    loadData();

    const openHistoryDialog = (id:number) => {
      historyViewDialogRef.value?.loadData(id);
    };
    return { dataRef, formatRate, formatUsdt, formatUsdtPlus, formatCoin, formatCoinPlus, openHistoryDialog, historyViewDialogRef };
  }
});
</script>

<style>
.tb{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #303133;
  font-size: 14px;
  border-collapse: collapse;
  width: 100%;
}
.td-head {
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: center;
  line-height: 23px;
  font-weight: 700;
  color: #606266;
  background-color: #f5f7fa;
  border: 1px solid #ebeef5;
  padding: 8px 11px;
}
.td-cell{
  color-scheme: light;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: right;
  font-weight: 400;
  line-height: 23px;
  color: #303133;
  border: 1px solid #ebeef5;
  padding: 8px 11px;
}
</style>
